
  module.exports =
  {
    search: require('./FibrePod/search'),
    orders: require('./FibrePod/orders'),
  }